import React, { FC } from 'react';
import { Form } from 'react-bootstrap';
import { Button } from '../../atoms';
import cn from 'classnames';
import styles from './LandscapeAboutContactPersonOrganism.module.css';
import { LandscapeContactPersonResponseDto } from '../../../store/landscapeAPI/landscape/dto/response/landscape-contact-person-response.dto';

interface LandscapeAboutContactPersonOrganismProps {
  handleOnChange: (contactPerson: LandscapeContactPersonResponseDto) => void;
  contactPerson: LandscapeContactPersonResponseDto;
  callbackFn: (contactPerson: LandscapeContactPersonResponseDto) => void;
  handleCancel: () => void;
}

const LandscapeAboutContactPersonOrganism: FC<
  LandscapeAboutContactPersonOrganismProps
> = ({ handleOnChange, contactPerson, callbackFn, handleCancel }) => {
  const handleSubmit: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    e.preventDefault();
    callbackFn(contactPerson);
  };

  return (
    <div className={cn(styles.landscapeAboutContactPersonWrapper)}>
      <Form>
        <Form.Group className="mb-3">
          <Form.Label>Role</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter role"
            onChange={(e) =>
              handleOnChange({ ...contactPerson, role: e.target.value })
            }
            value={contactPerson.role}
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Name</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter name"
            onChange={(e) =>
              handleOnChange({ ...contactPerson, name: e.target.value })
            }
            value={contactPerson.name ?? ''}
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Email address</Form.Label>
          <Form.Control
            type="email"
            placeholder="Enter email"
            onChange={(e) =>
              handleOnChange({ ...contactPerson, emailAddress: e.target.value })
            }
            value={contactPerson.emailAddress ?? ''}
          />
        </Form.Group>
        <div className={cn(styles.buttonsWrapper)}>
          <div className={cn(styles.button)}>
            <Button onClick={handleSubmit} variant="dark">
              Save
            </Button>
          </div>
          <div className={cn(styles.button)}>
            <Button onClick={handleCancel} variant="light">
              Cancel
            </Button>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default LandscapeAboutContactPersonOrganism;
